var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page-post"}},[_c('div',{staticClass:"xs-p-20 xs-fill-white"},[_c('div',{staticClass:"lg-container content-box"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])]),_vm._v(" "),_c('home-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bab372b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/static/Post.vue
// module id = DuyV
// module chunks = 24